import type { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { FormControl, FormControlLabel, FormLabel, RadioGroup, Radio } from '@mui/material';
import { Accordion, Text } from '@nxt-costco-com/forge-components';

import type { AccordionFormEntryProps } from 'src/components/CookieSettings/AccordionFormEntry/types';
import { SecondaryTitle } from 'src/components/CookieSettings/SecondaryTitle';
import { sectionHeaderPadding } from 'src/constants/styles';

export const AccordionFormEntry: FC<AccordionFormEntryProps> = (
    {
        children,
        setOptIn,
        categoryKey = 'saleOfInfo',
        isOptedIn,
        title
    }: AccordionFormEntryProps
) => {
    const { t } = useTranslation('translation');
    const cookieName = t(`accordians.${categoryKey}.cookieName`);
    let subtitle;
    if (isOptedIn) {
        subtitle = <SecondaryTitle color="green.500" text={t('states.isActive')} />;
    } else {
        subtitle = <SecondaryTitle color="gray.600" text={t('states.isDisabled')} />
    }

    return (
        <Accordion title={title} variant={'t5'}
            secondaryComponent={subtitle}
        >
            <>
                {children}
                <FormControl>
                    <FormLabel id={`radio-label-${categoryKey}`}>
                        <Text component="legend" bold={true} variant='t5' sx={sectionHeaderPadding}>
                            <Trans i18nKey={`optForm.question`} values={{cookieName}}>
                                Do you want {{cookieName}} on?
                            </Trans>
                        </Text>
                    </FormLabel>
                    <RadioGroup
                        aria-labelledby={`radio-label-${categoryKey}`}
                        value={isOptedIn ? "true" : "false"}
                        name={`radio-group-${categoryKey}`}
                        onChange={(e) => setOptIn(e.target.value === "true")}
                    >
                        <FormControlLabel value="true" control={<Radio />} label={t('optForm.isYes')} />
                        <FormControlLabel value="false" control={<Radio />} label={t('optForm.isNo')} />
                    </RadioGroup>
                </FormControl>
            </>
        </Accordion>
    );
}